import React, { useState } from 'react';
import { Box, Card, CardContent, Typography, IconButton, Button, Divider } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import LockIcon from '@mui/icons-material/Lock';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link, useNavigate } from 'react-router-dom';
import Header from 'components/Header';

import './FindAccount.css';
import FindIdPopup from 'components/FindPopup/FindIdPopup';
import FindPwPopup from 'components/FindPopup/FindPwPopup';
export default function FindAccount() {
  const navigate = useNavigate();
  const [openIdPopup, setOpenIdPopup] = useState(false);
  const [openPwPopup, setOpenPwPopup] = useState(false);

  // ID 팝업 열고 닫는 함수
  const handleOpenIdPopup = () => setOpenIdPopup(true);
  const handleCloseIdPopup = () => setOpenIdPopup(false);
  // PW 팝업 열고 닫는 함수
  const handleOpenPwPopup = () => setOpenPwPopup(true);
  const handleClosePwPopup = () => setOpenPwPopup(false);

  // 뒤로가기 버튼을 누르면 전 페이지로 이동
  const handleBackClick = () => {
    navigate(-1); // 브라우저의 히스토리에서 한 페이지 뒤로 이동
  };

  return (
    <main>
      <Header />
      <Divider />
      <Box sx={{ width: '80%', height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '0 auto' }}>
        {/* 뒤로가기 버튼 */}
        <Box sx={{ width: '70%', display: 'flex', justifyContent: 'flex-start', margin: '20px 0' }}>
          <IconButton onClick={handleBackClick}>
            <ArrowBackIcon />
            <Typography sx={{ marginLeft: '5px' }}>뒤로가기</Typography>
          </IconButton>
        </Box>

        {/* 두 개의 카드 */}
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: '60px', marginTop: '150px' }}>
          {/* 아이디 찾기 카드 */}
          <Card
            sx={{
              width: 450,
              height: 320,
              textAlign: 'center',
              border: '1px solid #90CAF9',
              cursor: 'pointer',
              alignContent: 'center',
              transition: 'transform 0.3s, box-shadow 0.3s', // 부드러운 애니메이션
              '&:hover': {
                transform: 'scale(1.02)', // 카드 크기 확대
                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)', // 그림자 추가
                backgroundColor: '#f0f8ff' // hover 시 살짝 어두운 색으로 변경
              }
            }}
            onClick={handleOpenIdPopup}
          >
            <CardContent>
              <PersonIcon sx={{ fontSize: 96, color: '#42A5F5' }} />
              <Typography variant="h4" component="div" className="cardTitle">
                아이디 찾기
              </Typography>
              <Typography sx={{ fontSize: 14, color: 'text.secondary', marginTop: '10px' }}>
                아이디를 잊었을 경우 정보를 입력하여 사용하던 아이디를 확인할 수 있습니다.
              </Typography>
            </CardContent>
          </Card>

          {/* 비밀번호 재설정 카드 */}
          <Card
            sx={{
              width: 450,
              height: 320,
              textAlign: 'center',
              border: '1px solid #90CAF9',
              cursor: 'pointer',
              alignContent: 'center',
              transition: 'transform 0.3s, box-shadow 0.3s', // 부드러운 애니메이션
              '&:hover': {
                transform: 'scale(1.02)', // 카드 크기 확대
                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)', // 그림자 추가
                backgroundColor: '#f0f8ff' // hover 시 살짝 어두운 색으로 변경
              }
            }}
            onClick={handleOpenPwPopup}
          >
            <CardContent>
              <LockIcon sx={{ fontSize: 96, color: '#42A5F5' }} />
              <Typography variant="h4" component="div" className="cardTitle">
                비밀번호 재설정
              </Typography>
              <Typography sx={{ fontSize: 14, color: 'text.secondary', marginTop: '10px' }}>
                비밀번호를 잊었을 경우 정보를 입력하여 비밀번호를 재설정할 수 있습니다.
              </Typography>
            </CardContent>
          </Card>
        </Box>

        {/* 아이디 찾기  Popup */}
        <FindIdPopup isOpen={openIdPopup} handleClose={handleCloseIdPopup} handleOpenPwPopup={handleOpenPwPopup} />

        {/* 비밀번호 재설정  Popup */}
        <FindPwPopup isOpen={openPwPopup} handleClose={handleClosePwPopup} />
      </Box>
    </main>
  );
}
